import React, { useState } from 'react'
import s from './style.module.css'
import useVizualisation from '../../helpers/useVizualisation'
import { Scrollama, Step } from 'react-scrollama'

const Scroller = ({ vizElement: Viz, scenes = [], ...rest }) => {
  const { ref, windowSize, height } = useVizualisation()
  const [vizProps, setVizProps] = useState(rest)
  return (
    <div className={s.wrap}>
      <div
        className={s.viz}
        style={{
          '--top-space': `${(windowSize.height - height) / 2}px`
        }}
      >
        <div className={s.inner} ref={ref}>
          <Viz {...rest} {...vizProps} />
        </div>
      </div>

      <Scrollama
        offset={1}
        onStepEnter={({ elem, data }) => {
          setVizProps(data)
        }}
      >
        {scenes.map((scene, i) => {
          return (
            <Step
              data={{ ...scene, scrollerNum: i, index: i }}
              // index={i}
              key={`scene-${i}`}
            >
              <div className={s.scene}>
                <div className={s.text}>
                  {scene.title && <h3 className={s.title}>{scene.title}</h3>}
                  <p dangerouslySetInnerHTML={{ __html: scene.text }} />
                </div>
              </div>
            </Step>
          )
        })}
      </Scrollama>
    </div>
  )
}

export default Scroller
